import { contractConstants } from "./action-types";
import { contractDataApi } from "../utils/api";
import { checkIfDisabled, createOfferContractTypes, listingContractTypes,   } from "../../Common/commondata/commonData";
import { contractStoreHandle } from "../../ContractStore/state/actions";
import { features } from "../features/features";
import { decryptQuery, extractUniqueClientIds, formatAndParse, updateClientDetails } from "../../Common/utils/universalFuntions";
import { closingActions } from "../../TransactionReport/state/actions";
import { message } from "antd";
import moment from "moment";
import calculatePriceTable from "../features/helpers/calculatePriceTable";
import { transactionLaneConstants } from "../../Rtd/state/action-types";
import dotEnv from "dotenv";
dotEnv.config();

/**
 * All Actions for contract Page
 */

/**
 * To update Navbar title action
 * @param {string}
 */

const setUrlIdFun = (urlId) => {
  return {
    type: contractConstants.SET_URL_ID,
    currentUrlId: urlId,
  };
};
const setAuthKeyForContractFun = (key) => {
  return {
    type: contractConstants.SET_AUTH_KEY_FOR_CONTRACT,
    contractAuthKey: key,
  };
};
const setRootLevelDocDataFun = (payload) => {
  return {
    type: contractConstants.SET_READ_ONLY_DATA_FOR_CONTRACT,
    rootDocData: payload,
  };
};
const setLoadingSave = (data) => {
  return {
    type: contractConstants.SET_LOADING_SAVE,
    loadingSave: data,
  };
};

const setError = (data) => {
  return {
    type: contractConstants.VERIFY_OTP_ERROR,
    error: data,
  };
};

const contractError = (error) => {
  return {
    type: contractConstants.CONTRACT_PAGE_FAILURE,
    contractError: error,
    contractLoading: false,
  };
};

const contractSuccess = (response) => {
  return {
    type: contractConstants.CONTRACT_PAGE_SUCCESS,
    contractData: response.data.info,
    contractLoading: false,
  };
};

const getContractData = (id, authKey, contractType, RTDInitiator, arrayDoc = []) => {
  return (dispatch) => {
    contractDataApi
      .contractPageLoadRequest(id, authKey, RTDInitiator)
      .then((response) => {
        dispatch(getCreateOfferSuccess(...arrayDoc, response.data.info));
        dispatch(contractSuccess(response));
      
        // dispatch(setLoadingSave(false));
      })
      .catch((error) => {
        dispatch(contractError(error));
      });
  };
};

const getPersistDeatailsDataOnly=(documentId, token, rootDocData)=>{
  return (dispatch, getState) => {
    contractDataApi
      .getPersistdetailsDataRequest(documentId,token)
      .then((response) => {
        let docResponse = response.data?.info || {};
        let checkForDisable = checkIfDisabled({openFor: rootDocData?.openFor, contractData: docResponse.contractId, offerStatus: docResponse?.offerData?.status, actualPropertyStatus: docResponse?.propertyData?.status, sellingStatus: docResponse?.offerData?.sellingStatus, buyingStatus: docResponse?.offerData?.buyingStatus, personStatus: docResponse?.personStatus});
        docResponse.checkForDisable = checkForDisable;
        delete docResponse?.transactionData;
        dispatch(contractDataHandle.setRootLevelDocDataFun(docResponse));
      }).catch((error) => {
        console.log('error', error, error.response);
        if (error?.response?.data?.message === "No subscription exists!" || error?.response?.data?.message?.toLowerCase()?.includes("subscription")) {
          // message.error(error?.response?.data?.message);
          window.location.href = `${process.env.REACT_APP_WEB_BASE_URL}`;
        } else {
          message.error(error?.response?.data?.message || "Please try again later!");
        }
      });
}}
const getPersistDeatailsData = (documentId, buildData, source, persistDateCalendar) => {
  // console.log("documentId", documentId, buildData, source);
  return (dispatch, getState) => {
    contractDataApi
      .getPersistdetailsDataRequest(documentId, buildData.token, buildData)
      .then((response) => {
        localStorage.setItem(buildData._id, JSON.stringify(response.data.info?.transactionData || {}));
        let docResponse = response.data?.info;
        let checkForDisable = checkIfDisabled({openFor: buildData?.openFor, contractData: docResponse.contractId, offerStatus: docResponse?.offerData?.status, actualPropertyStatus: docResponse?.propertyData?.status, sellingStatus: docResponse?.offerData?.sellingStatus, buyingStatus: docResponse?.offerData?.buyingStatus, personStatus: docResponse?.personStatus});
        docResponse.checkForDisable = checkForDisable;
        let contractId;
  
        if (source === "CONTRACT") {
          if (docResponse?.documentType === "TEMPLATE" && !docResponse?.contractId?._id) {
           contractId="66ab7a6a7bfcc2a4deedb08d" // new CBSR
          } else {
            contractId=docResponse?.contractId?._id
         }
          dispatch(getContractData(contractId, buildData?.token, docResponse?.contractType, docResponse?.RTDInitiator, [docResponse, documentId, buildData, persistDateCalendar, docResponse?.offerId]));
        }
      })
      .catch((error) => {
        console.log('error', error, error.response);
        if (error?.response?.data?.message === "No subscription exists!" || error?.response?.data?.message?.toLowerCase()?.includes("subscription")) {
          // message.error(error?.response?.data?.message);
          window.location.href = `${process.env.REACT_APP_WEB_BASE_URL}`;
        } else {
          message.error(error?.response?.data?.message || "Please try again later!");
        }
      });
  };
};

// get all create offer params from the id
const getCreateOfferError = (error) => {
  return {
    type: contractConstants.CREATE_OFFER_FAILURE,
    createOfferError: error,
    createOfferLoading: false,
  };
};

const getCreateOfferSuccess = (originalText, documentId, buildData, persistDateCalendar,offerId, contractData) => {
  //originalText====Document Response or get Url Response when documentId is not Present
  let combinedData;
  if (documentId) {
    let createOfferDatatemp, tempRootDocData;
    let { transactionData={}, ...rootDocData } = originalText || {};
    let { urlData = {}, ...rootData } = buildData || {};
    createOfferDatatemp = {
      ...(urlData),
      ...(transactionData),
    };
    tempRootDocData = {
      ...(rootData?{...rootData}: {}),
      urlId: buildData._id,
      ...(rootDocData && rootDocData),
    };
    if (persistDateCalendar) {
      createOfferDatatemp["documentId"] = null;
    }
    combinedData = {
      createOfferData: createOfferDatatemp,
      rootDocData: tempRootDocData,
    };
  } else {
    let { urlData={}, ...rootDocData } = originalText || {};
    combinedData = {
      createOfferData: urlData,
      rootDocData: {
        ...(rootDocData && rootDocData),
        urlId: rootDocData?._id,
      },
    };
  }
  const createOfferData = combinedData?.createOfferData||{};
  const rootDocData = combinedData?.rootDocData || {};

  if (rootDocData?.contractType === "NET_SHEET") {
    // rootDocData.TotalEstimateNetProceeds = createOfferData?.TotalEstimateNetProceeds;
    rootDocData.netSheetTransactionData = createOfferData;
  }

  let paramsData = {}, priceTableData={}, templateDateTableData={};
  if (rootDocData) {
    paramsData = {
      ...createOfferData,
    };
    if (!rootDocData.documentId && rootDocData?.builtForSection === "DOCUMENT" && createOfferContractTypes.includes(rootDocData?.contractType)) {
      const tableValues = {};
      let purchasePrise = formatAndParse(createOfferData["PurchasePrice"]);
      let earnestMoney = formatAndParse((purchasePrise * 1) / 100)
      tableValues["PurchasePrice"] = purchasePrise;
      tableValues["EarnestMoney"] = createOfferData["EarnestMoney"] ? formatAndParse(createOfferData["EarnestMoney"]) : earnestMoney;
      tableValues["NewLoan"] =  formatAndParse((purchasePrise * 95) / 100);
      tableValues["AssumptionBalance"] = 0;
      tableValues["PrivateFinancing"] = 0;
      tableValues["SellerFinancing"] = 0;
      tableValues["AdditionalPriceAmt1"] = 0;
      tableValues["AdditionalPriceAmt2"] = 0;
      tableValues["CashAtClosing"] = formatAndParse((purchasePrise * 4) / 100);
      priceTableData = calculatePriceTable(tableValues);
 
      // date logic
      const currentDate = moment();
      const closingDate = moment(createOfferData.ClosingDate);

      if (!rootDocData?.contractType?.startsWith("WY_") && closingDate && closingDate.diff(currentDate, "days") > 29) {
        paramsData.AutoFillDates = "AutoFillDates";
        features.autoFillDateLogic({currentUrlId: rootDocData.urlId, source: "Initial", templateDateTableData, contractData});
      }
    } else {
      paramsData.urlId = rootDocData.urlId;
    }
    let temp1Element = JSON.parse(localStorage.getItem(rootDocData.urlId)) || {};
    // console.log("temp1Element", temp1Element["Buyers"] || []);
    if (!documentId) {
      paramsData["Buyers"] = temp1Element["Buyers"] || [];
      paramsData["Sellers"] = temp1Element["Sellers"] || [];
    }
    localStorage.setItem(rootDocData.urlId, JSON.stringify({ ...temp1Element, ...paramsData, ...priceTableData, ...templateDateTableData }));
  }
  return {
    type: contractConstants.CREATE_OFFER_SUCCESS,
    ...combinedData,
    createOfferLoading: false,
    ...(offerId && {offerId})
  };
};
/*
first stape
when the offer document loads it will always fetch url data
*/
const getCreateOfferData = ({ urlId, unmounted, sourceAxios, sendEmail, history }) => {
  return async (dispatch) => {
    try {
      const response = await contractDataApi.getCreateOfferDataRequest({ urlId, unmounted, sourceAxios });
      let originalText = decryptQuery(response.data.info);

      if (!originalText) {
        return dispatch(
          setError({
            message: "Accessing link does not exists",
            statusCode: 400,
          })
        );
      }
      console.log("originalText", originalText);
      if (unmounted?.value) {
        return;
      }
      localStorage.setItem(urlId, JSON.stringify(originalText.urlData || {}));
      dispatch(setAuthKeyForContractFun(originalText.token));
      if (originalText?.contractType === "TR") {
        dispatch(contractStoreHandle.getTransactionReportMethod({ offerId: originalText.offerId, accessToken: originalText.token, contractType: originalText?.contractType, openFor: originalText?.openFor }));
        dispatch(closingActions.transactionReportEmail(originalText.offerId, originalText.token, {openFor: originalText?.openFor}));
        dispatch(closingActions.getEmailLogs({accessToken: originalText.token, unmounted, queryData: {offerId: originalText.offerId, propertyId: originalText.propertyId, fetchType: 'PARTIAL', ...(["SELLER", "SELLER_AGENT"].includes(originalText?.openFor) ? {viewFrom: "SELLING", openFor: "SELLER_AGENT"} : ["BUYER", "BUYER_AGENT"].includes(originalText?.openFor) ? {viewFrom: "BUYING", openFor: "BUYER_AGENT"} : {})}}));
        dispatch(closingActions.getSharedDocs(originalText.offerId, originalText.token, originalText?.openFor));
        if (originalText.documentId) {
          console.log("A");
          dispatch(getPersistDeatailsData(originalText?.documentId, originalText, "CONTRACT"));
        } else {
          console.log("B");
          if (originalText?.contractId) {
            dispatch(getContractData(originalText?.contractId, originalText?.token, originalText?.contractType, null, [originalText, null, null, null, null]));
          }
        }
        setTimeout(() => {
          dispatch(contractStoreHandle.autoSaveContract({ currentUrlId: urlId, contractAuthKey: originalText.token }));
        }, 3000);
      } else {
        if (originalText.documentId) {
          console.log("A");
          // if (Object.keys(originalText?.deletedById).length !== 0 && originalText?.deletedById?._id) {
          //   let isAgent = false;
          //   if (originalText?.openFor === "SELLER_AGENT" || originalText?.openFor === "BUYER_AGENT") {
          //     isAgent = true
          //   }
          //   history.push({
          //     pathname: "/deletedDocumentSuccess",
          //     search: `?isAgent=${isAgent}`,
          //     state: { deletedById: originalText?.deletedById },
          //   });
          // }else{
          // }
          dispatch(getPersistDeatailsData(originalText?.documentId, originalText, "CONTRACT"));
          // offerCreation with template
        } else {
          console.log("B");
          if (originalText?.contractId) {
            // if ([...listingContractTypes, "ERTB", "CB_ERTB"].includes(originalText?.contractType)) {
              const buyerIds = extractUniqueClientIds(originalText.urlData?.Buyers);
              const sellerIds = extractUniqueClientIds(originalText.urlData?.Sellers);
              const clientIds = [...new Set([...buyerIds, ...sellerIds])];
              await dispatch(getAllClientDetails({ clientIds, accessToken: originalText?.token, currentUrlId: urlId, originalText }));
            // } else {
            
              // dispatch(getContractData(originalText?.contractId, originalText?.token, originalText?.contractType, originalText?.RTDInitiator, [originalText, null, null, null, null]));
            // }
          } else {
            dispatch(getCreateOfferSuccess(originalText, null, null));
          }
          if (originalText?.contractType === "TO") {
            // To take buyers and seller populated data calling extra API for TO form like TR form
            dispatch(contractStoreHandle.getTransactionReportMethod({ offerId: originalText.offerId, accessToken: originalText.token, contractType: originalText?.contractType, td: originalText?.urlData, urlId, openFor: originalText?.openFor }));
          }
        }
      }
    } catch (error) {
      if (!unmounted?.value) {
        dispatch(getCreateOfferError(error));
      }
    }
  };
};

const getAllContactDetails = () => ({
  type: contractConstants.RESET_COMPRESSED_VIEW,
});
const resetCompressedViewData = () => ({
  type: contractConstants.RESET_COMPRESSED_VIEW,
});
const setDrawerPosition = (payload) =>({
  type: contractConstants.SET_DRAWER_POSITION,
  setDrawer:payload,
});

const getEmailContents = (payload, accessToken) =>{
  return (dispatch, getState) => {
    dispatch(getEmailContentsLoading(true));
    contractDataApi.getEmailContentsRequest(payload, accessToken)
    .then((response)=> {
      dispatch(getEmailContentsSuccess(response))
    })
    .catch((error)=> {
      dispatch(getEmailContentsError(true));
    })
    .finally(() => {
      dispatch(getEmailContentsLoading(false));
    });
  }
};

const getEmailContentsSuccess = (response) => {
  return {
    type: contractConstants.GET_EMAIL_CONTENT_SUCCESS,
    setEmailData: response?.data?.info,
    setEmailLoading: false,
    setEmailError: false,
  }
}

const getEmailContentsLoading = (payload) => {
  return {
    type: contractConstants.GET_EMAIL_CONTENT_LOADING,
    setEmailLoading: payload,
    setEmailError: false,
  }
}

const getEmailContentsError = (payload) => {
  return {
    type: contractConstants.GET_EMAIL_CONTENT_ERROR,
    setEmailLoading: false,
    setEmailError: payload,
  }
}
// Get Property Docs
const getClientDocRequestLoading = (error) => {
  return {
    type: contractConstants.GET_CLIENT_DOC_LOADING,
    uploadPdfError: error,
    uploadPdfLoading: false,
  };
};

const getAgentDetailsSuccess = (data) => {
  return {
    type: contractConstants.GET_AGENT_DETAILS_SUCCESS,
    agentDetailsData: data,
  }
}

const getAgentDetailsLoading = (payload) => {
  return {
    type: contractConstants.GET_AGENT_DETAILS_LOADING,
    agentDetailsLoading: payload
  }
}
const setAgentDetailsData = (payload) => {
  return {
    type: contractConstants.SET_AGENT_DETAILS_DATA,
    agentDetailsData: payload
  }
}

const getAllClientDetailsLoading = (payload) => {
  return {
    type: contractConstants.GET_ALL_CLIENT_DETAILS_LOADING,
    allClientDetailsLoading: payload
  }
}
const getAllClientDetailsSuccess = (clientDetails) => {
  return {
    type: contractConstants.GET_ALL_CLIENT_DETAILS_SUCCESS,
    allClientDetailsData: clientDetails
  }
}

const getAllClientDetails = ({ clientIds, accessToken ,currentUrlId, originalText, contractId, source, sourceAxios, unmounted}) =>{
  return (dispatch) => {
    if (source === 'EDIT_CLIENT_MODAL') {
      dispatch(getAllClientDetailsLoading(true));
    }
    contractDataApi.getAllClientDetailsRequest({ clientIds, accessToken, sourceAxios })
      .then((response) => {
        let clientDetails = response?.data?.info || [];
        if (clientDetails) {
          let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
          localData["Buyers"] = updateClientDetails(clientDetails, localData["Buyers"] || []);
          localData["Sellers"] = updateClientDetails(clientDetails, localData["Sellers"] || []);
          localStorage.setItem(currentUrlId, JSON.stringify(localData));
        }
        if (source === 'EDIT_CLIENT_MODAL' && !unmounted?.value) {
          dispatch(getAllClientDetailsSuccess(clientDetails));
        } else if (contractId || originalText?.contractId) {
          dispatch(getContractData(contractId || originalText?.contractId, originalText?.token, originalText?.contractType, originalText?.RTDInitiator, [originalText, null, null, null, null]));
        }
    })
    .catch((error)=> {
      if (source === 'EDIT_CLIENT_MODAL') {
        dispatch(getAllClientDetailsLoading(false));
      } else {
        message.error(error?.response?.data?.message || "We encountered an issue in fetching the Agent Details. Please try after some time.");
      }
    })
    .finally(() => {
     
    });
  }
};
const getAgentDetails = ({ query, accessToken }) =>{
  return (dispatch, getState) => {
    dispatch(getAgentDetailsLoading(true));
    contractDataApi.getAgentDataDetailsRequest({ query, accessToken })
      .then((response) => {
        if (response.data.info._id) {
          dispatch(getAgentDetailsSuccess(response.data.info))
        } else {
          message.error("No account exists with this email address.")
      }
    })
    .catch((error)=> {
      message.error(error?.response?.data?.message || "We encountered an issue in fetching the Agemt Details. Please try after some time.");
    })
    .finally(() => {
      dispatch(getAgentDetailsLoading(false));
    });
  }
};






const getClientDocRequestSuccess = (transactionData, contactDocs) => {
  return {
    type: contractConstants.GET_CLIENT_DOC_SUCCESS,
    propertyDocs: transactionData,
    ...(contactDocs && {contactDocs}),
    uploadPdfLoading: false,
  };
};

const getClientDocRequestError = (error) => {
  return {
    type: contractConstants.GET_CLIENT_DOC_ERROR,
    uploadPdfError: error,
    uploadPdfLoading: false,
  };
};

const getPropertyDocsDataSuccess = (transactionData) => {
  return {
    type: transactionLaneConstants.GET_PROPERTY_DOC_WITHOUT_SECTION_SUCCESS,
    propertyDocsWithoutSection:transactionData,
    propertyDocs: transactionData,
  }
}

const getPropertyDocsFun = ({params, unmounted, source,contractAuthKey}) => {
  return (dispatch, getState) => {
    dispatch(getClientDocRequestLoading());
    contractDataApi
      .getClientDocRequest({params, source,contractAuthKey})
      .then((response) => {
        if(!unmounted?.value){
          if(params?.section === "SEND_DOCUMENT"){
            dispatch(getClientDocRequestSuccess(response?.data?.info?.transactionDocs || [], response?.data?.info?.contactDocs || []));
          }
          else{
            dispatch(getPropertyDocsDataSuccess(response?.data?.info));
          }
        }
      })
      .catch((error) => {
        if(!unmounted?.value){
          dispatch(getClientDocRequestError(error));
          message.error(
            error?.response?.data?.message || "Error occured while getting property docs data!",
          );
        }
      });
  };
};
//Get Person Docs
const getPersonDocsLoading = () => {
  return {
    type: contractConstants.PERSON_DOCS_LOADING,
  };
};
const getPersonDocsError = (error) => {
  return {
    type: contractConstants.PERSON_DOCS_FAILURE,
    personDocsError: error,
  };
};

const getPersonDocsSuccess = (response) => {
  return {
    type: contractConstants.PERSON_DOCS_SUCCESS,
    personDocs: response.data.info,
  };
};

const getPersonDocs = ({customerIds, unmounted, source,contractAuthKey}) => (dispatch) => {
  dispatch(getPersonDocsLoading());
  return contractDataApi
    .getPersonDocsRequest({customerIds, source,contractAuthKey})
    .then((response) => {
      if(!unmounted.value){
        dispatch(getPersonDocsSuccess(response));
      }
    })
    .catch((error) => {
      if(!unmounted.value){
        message.error(error?.response?.data?.message || "We encountered an issue while getting person documents. Please try again later!", 2);
        dispatch(getPersonDocsError(error));
      }
    });
};

const getSowCoDataLoading = () => {
  return {
    type: contractConstants.SOW_DATA_LOADING,
  };
};
const getSowCoDataLoadingError = (error) => {
  return {
    type: contractConstants.SOW_DATA_ERROR,
    sowCoDataError: error.response.data.message || "We encountered an issue while getting source of water companies, Please try again!",
  };
};

const getSowCoDataRequestSuccess = (response) => {
  return {
    type: contractConstants.SOW_DATA_SUCCESS,
    soaCoRecords: response.data.info,
  };
};

const getSowCoData = ({ unmounted, sourceAxios, contractAuthKey, pageNumber, limit, searchObj }) => {
  return (dispatch, getState) => {
    dispatch(getSowCoDataLoading());
    contractDataApi.getSowCoDataRequest({ sourceAxios, contractAuthKey, pageNumber, limit, searchObj })
      .then((response) => {
        if (!unmounted.value) {
          dispatch(getSowCoDataRequestSuccess(response));
        }
      })
      .catch((error) => {
        if (!unmounted.value) {
          message.error(error?.response?.data?.message || "We encountered an issue while getting source of water companies, Please try again!");
          dispatch(getSowCoDataLoadingError(error));
        }
      })
  }
}

export const contractDataHandle = {
  getContractData,
  resetCompressedViewData,
  getCreateOfferData,
  setLoadingSave,
  setError,
  setUrlIdFun,
  setAuthKeyForContractFun,
  setRootLevelDocDataFun,
  setDrawerPosition,
  getEmailContents,
  getAgentDetails,
  setAgentDetailsData,
  getPropertyDocsFun,
  getPersonDocs,
  getPersistDeatailsDataOnly,
  getSowCoData, 
  getAllClientDetails,
};
